import { put, call, takeEvery } from "redux-saga/effects";

import * as apis from "../../../network/apis/clientPortalNotifications";
import {
  getClientNotificationsResponse,
  getClientDropdownNotificationsResponse,
  setClientUnseenNotificationsCount,
  replaceClientNotification,
} from "./actions";
import * as types from "./types";
import { showErrorMsg } from "../../../utils/Helpers";

function* getClientNotificationsSaga({ payload }) {
  try {
    const response = yield call(apis.getClientPortalNotifications, payload);
    yield put(
      getClientNotificationsResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      }),
    );
    yield put(setClientUnseenNotificationsCount(0));
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

function* getClientDropdownNotificationsSaga({ payload }) {
  try {
    const response = yield call(apis.getClientPortalNotifications, payload);
    yield put(getClientDropdownNotificationsResponse(response.data.data));
    yield put(setClientUnseenNotificationsCount(0));
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

function* setClientNotificationSeenSaga({ payload }) {
  try {
    const response = yield call(apis.setClientPortalNotificationSeen, payload);
    yield put(replaceClientNotification(response.data.data));
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

export default function* ClientNotificationsSagas() {
  yield takeEvery(
    types.GET_CLIENT_NOTIFICATIONS_REQUEST,
    getClientNotificationsSaga,
  );
  yield takeEvery(
    types.GET_CLIENT_DROPDOWN_NOTIFICATIONS_REQUEST,
    getClientDropdownNotificationsSaga,
  );
  yield takeEvery(
    types.SET_CLIENT_NOTIFICATION_SEEN,
    setClientNotificationSeenSaga,
  );
}
